// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

// HubEndPointforAppChange variable is used for `login as buyer/supplier` feature from user lists.

export const environment = {
  production: true,
  version: '8.0.3',
  APIEndPoint: 'https://api.mfg.com/api/',
  HubEndPointforAppChange: 'https://app.mfg.com/',
  mixpanelProjectKey: '111eb6613bb9cd4f13b1d7b05511f22e',
  widgetApiKey: ''
};



// WEBPACK FOOTER //
// ./src/environments/environment.ts